// This file registers our custom service worker.

// Check if the browser supports service workers.
if ("serviceWorker" in navigator) {
	// Listen for the 'load' event on the window to ensure our site is ready.
	window.addEventListener("load", () => {
		// Register the service worker, which is located in the root of our site.
		// Gatsby's build process moves the file to the root.
		navigator.serviceWorker
			.register("/service-worker.js")
			.then((registration) => {
				console.log(
					"Service Worker registration successful with scope: ",
					registration.scope
				)
			})
			.catch((err) => {
				console.log("Service Worker registration failed: ", err)
			})
	})
}
